import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { customLayout } from 'app/models/customLayout.model';
import { environment } from '@env/environment';
import { CommonApiService } from './common-api.service';

@Injectable({ providedIn: 'root' })
export class CustomLayoutService {
  private apiUrl = `${environment.baseUrl}/customLayouts`;

  constructor(private http: HttpClient, private commonAPI: CommonApiService) { }

  getcustomLayoutList(): Observable<any> {
    return this.commonAPI.getApiCall(`${this.apiUrl}/getAllcustomLayouts`);
  }

  getcustomLayoutWithSC(shortcode: string): Observable<any> {
    //debugger;
    console.log(`${this.apiUrl}/getcustomLayoutByShortCode/${shortcode}`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getcustomLayoutByShortCode/${shortcode}`);
    // return this.http.get(`${this.apiUrl}/getcustomLayoutByShortCode/${shortcode}`);
  }

  getcustomLayoutLinesByShortCode(shortcode: string): Observable<any> {
    console.log(`${this.apiUrl}/getcustomLayoutLinesByShortCode/${shortcode}`);
    // let aaa = this.http.get(`${this.apiUrl}/getcustomLayoutLinesByShortCode/${shortcode}`);
    // console.log(aaa);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getcustomLayoutLinesByShortCode/${shortcode}`);
    // return this.http.get(`${this.apiUrl}/getcustomLayoutLinesByShortCode/${shortcode}`);
  }

  /**
   * Save layout master + lines.
   * Contract (aligned with slide-type / object-group): flat fields under criteria.
   * details must be an array of layout line objects (not a string).
   * Also accepts legacy LayoutLinesArr and maps it to details.
   */
  savecustomLayout(customLayout: any): Observable<any> {
    console.log(customLayout);
    const detailsRaw = customLayout?.details ?? customLayout?.LayoutLinesArr ?? [];
    const details = Array.isArray(detailsRaw)
      ? detailsRaw
      : (typeof detailsRaw === 'string'
        ? (() => { try { const p = JSON.parse(detailsRaw || '[]'); return Array.isArray(p) ? p : []; } catch { return []; } })()
        : []);

    const body = {
      criteria: {
        LayoutShortCode: customLayout?.LayoutShortCode ?? '',
        LayoutDescription: customLayout?.LayoutDescription ?? '',
        LayoutRemarks: customLayout?.LayoutRemarks ?? '',
        details,
        tenant: null,
      },
    };

    return this.commonAPI.postApiCall(`${this.apiUrl}/saveLayout`, body);
  }

  getSlideObjectTypes(showin: string): Observable<any> {
    console.log(`${this.apiUrl}/getSlideObjectTypes`);

    return this.commonAPI.getApiCall(`${this.apiUrl}/getSlideObjectTypes/${showin}`);
    // return this.http.get(`${this.apiUrl}/getSlideObjectTypes/${showin}`);
  }

  deletecustomLayout(shortcode: string): Observable<any> {

  const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = {
      "criteria": {
        "LayoutShortCode": shortcode,
        tenant: null
      }
    };

    let aaa= this.commonAPI.postApiCall(`${this.apiUrl}/deleteLayout`, body);
    console.log(aaa);
    return aaa;

    // return this.http.delete(`${this.apiUrl}/DeletecustomLayout/${shortcode}`);
  }
}
